/**
 * @file
 * Scripts file
 *
 * =============================
 * === DO NOT EDIT THIS FILE ===
 * =============================
 *
 * General scripting file. This file is compiled
 * via the `scripts` task in gulp, and is built using
 * all of the JS files inside of the sass directory.
 *
 * To add new code to this file, add a new
 * component-name.behaviors.js file in the directory for
 * that particular component in the sass directory.
 *
 * For an example, see `sass/components/main-menu/`
 */
(function ($, Drupal) {

  //'use strict';

  $('body').removeClass('no-js');

  /**
   * =============================
   * ==== BEGIN COMPONENTS JS ====
   * =============================
   */
